<template>
  <div
    v-if="isLoggedIn && $vuetify.display.mobile && !webViewMode"
    id="bottom-nav-container"
    class="color-top-bar-text background-top-bar-background fill-width"
  >
    <div class="bottom-navigation fill-width" :style="{ height: mobileBottomBarHeight }">
      <nav-buttons />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "pinia"

import { useAppStateStore } from "@/store/appState.js"
import { useUserSessionStore } from "@/store/userSession.js"

import NavButtons from "@/components/navs/NavButtons.vue"

export default {
  components: {
    NavButtons
  },
  computed: {
    ...mapGetters(useUserSessionStore, ["isLoggedIn"]),
    ...mapGetters(useAppStateStore, ["mobileBottomBarHeight", "webViewMode"])
  }
}
</script>

<style lang="scss" scoped>
$additional-padding: 8px;

#bottom-nav-container {
  position: fixed;
  bottom: 0;
  left: 0;
  height: var(--mobile-bottom-bar-height);
  z-index: var(--z-index-top-headers);

  .bottom-navigation {
    box-shadow: var(--shadow-2);
    bottom: 0;
    position: absolute;

    :deep(.buttons-container) {
      bottom: 0;
      height: var(--mobile-bottom-bar-height);
      padding-bottom: var(--mobile-bottom-bar-padding);

      .v-btn {
        min-width: 64px !important;
        width: auto;

        &:before {
          border-radius: var(--rounded-circle);
        }

        &.v-btn.nav-active {
          padding-top: 0;
        }

        &:not(.nav-active) {
          filter: none;
          color: inherit !important;
        }
      }
    }
  }

  :deep(.v-btn--icon) {
    height: var(--mobile-bottom-bar-buttons-area-height) !important;
  }
}
</style>
